import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { templateReducer } from '@modules/template/student/store/template.reducer';
import { TemplateEffects } from '@modules/template/student/store/template.effects';
import { TemplateStoreService } from '@modules/template/student/store/services/template-store.service';
import { templateFeatureKey } from './template.state';

@NgModule({
  imports: [StoreModule.forFeature(templateFeatureKey, templateReducer), EffectsModule.forFeature([TemplateEffects])],
  providers: [TemplateStoreService],
})
export class TemplateStoreModule {}
